export default "__VITE_ASSET__DQVAx7gR__"